import { createSlice } from '@reduxjs/toolkit';

export const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    totalQuantity: 0,
  },
  reducers: {
    addToCart: (state, { payload }) => {
      const existingItem = state.items.find(item => item.id === payload.id);
      if (existingItem) {
        existingItem.quantity += payload.quantity;
      } else {
        state.items.push(payload);
      }
      state.totalQuantity += payload.quantity;
    },
    // removeFromCart: (state, { payload }) => {
    //   const existingItem = state.items.find(item => item.id === payload.id);
    //   if (existingItem) {
    //     state.totalQuantity -= existingItem.quantity;
    //     state.items = state.items.filter(item => item.id !== payload.id);
    //   }
    // },
    removeFromCart: (state, { payload }) => {
      const existingItem = state.items.find(item => item.id === payload.id);
      if (existingItem) {
        if (existingItem.quantity > payload.quantity) {
          existingItem.quantity -= payload.quantity;
          state.totalQuantity -= payload.quantity;
        } else {
          // If the quantity to remove is equal to or more than the existing quantity, remove the item
          state.items = state.items.filter(item => item.id !== payload.id);
          state.totalQuantity -= existingItem.quantity;
        }
      }
    },
    updateItemQuantity: (state, { payload }) => {
      const existingItem = state.items.find(item => item.id === payload.id);
      if (existingItem) {
        existingItem.quantity = payload.quantity;
      }
    },

    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
    }
  },
});

export const { addToCart, removeFromCart, clearCart, updateItemQuantity } = cartSlice.actions;

export default cartSlice.reducer;


